import React from "react";
import ReactToPrint from "react-to-print";
import Card from "../../ReceiptManagement/List/SubscriberCard";
import ReceiptCard from "../../ReceiptManagement/List/ReceiptCard";
import ReceiptView from "../../ReceiptManagement/List/ReceiptView";
import { HiOutlinePrinter, HiOutlineDocumentText } from 'react-icons/hi';

const PrintButton = ({ subscriberRecord, currentRecord }) => {
  // Ref to the component to be printed
  const componentRef = React.useRef();

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900">Payment Receipt</h2>
        <p className="mt-1 text-sm text-gray-500">View and print your payment confirmation</p>
      </div>

      {currentRecord?.payment_status === '1' && (
        <div className="mb-6">
          <ReactToPrint
            trigger={() => (
              <button className="inline-flex items-center px-4 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-lg shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200">
                <HiOutlinePrinter className="w-5 h-5 mr-2" />
                Download Receipt
              </button>
            )}
            content={() => componentRef.current}
          />
        </div>
      )}

      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center space-x-2">
              <HiOutlineDocumentText className="w-6 h-6 text-gray-400" />
              <h3 className="text-lg font-medium text-gray-900">Receipt Preview</h3>
            </div>
          </div>
          <div className="space-y-6">
            <Card data={subscriberRecord} />
            <ReceiptCard data={currentRecord} users={subscriberRecord} />
          </div>
        </div>
      </div>

      {/* Hidden print component */}
      <div className="hidden">
        <div ref={componentRef}>
          <ReceiptView
            subscriberRecord={subscriberRecord}
            currentRecord={currentRecord}
          />
        </div>
      </div>
    </div>
  );
};

export default PrintButton;
